import {
  AUTH_ACTION,
  REVOKE_AUTH_ACTION,
  GET_USER_AGENZIE,
  SET_USER_AGENZIA,
  LOCK_USER_AGENZIA,
  UNLOCK_USER_AGENZIA,
  GET_USER_ROLES,
  GET_USER_ACL,
  GET_USER_PROFILES,
  GET_COLLABORATORE_ID,
  BLOCK_ACCESS_CAMPUS,
  SET_IS_TUTOR,
  USER_NOT_FOUND,
  GET_USER_AGENZIE_FOR_DASHBOARD,
  ERROR_USER_ACL,
} from './constants';

export function authAction(session) {
  const sessionString = JSON.stringify(session);
  localStorage.setItem('session', sessionString);

  return {
    type: AUTH_ACTION,
    session,
  };
}

export function revokeAuthAction() {
  localStorage.removeItem('session');
  localStorage.removeItem('classic_mode_filter');
  localStorage.removeItem('kanban_mode_filter');
  localStorage.removeItem('importazioni_filter');
  sessionStorage.removeItem('importazioni_filter');

  return {
    type: REVOKE_AUTH_ACTION,
  };
}

export function blockAccessCampus() {
  return {
    type: BLOCK_ACCESS_CAMPUS,
  };
}

export function setIsTutor() {
  return {
    type: SET_IS_TUTOR,
  };
}

export function userNotFound() {
  return {
    type: USER_NOT_FOUND,
  };
}

export function getUserAgenzie(agenzie) {
  return {
    type: GET_USER_AGENZIE,
    agenzie,
  };
}

export function getUserAgenzieForDashboard(agenzieForDashboard) {
  return {
    type: GET_USER_AGENZIE_FOR_DASHBOARD,
    agenzieForDashboard,
  };
}

export function getCollaboratoreID(id) {
  return {
    type: GET_COLLABORATORE_ID,
    id,
  };
}

export function getUserRoles(ruoli) {
  return {
    type: GET_USER_ROLES,
    ruoli,
  };
}

export function getUserProfiles(profili) {
  return {
    type: GET_USER_PROFILES,
    profili,
  };
}

export function getUserACL(gruppi) {
  return {
    type: GET_USER_ACL,
    gruppi,
  };
}

export function setUserAgenzia(agenzia) {
  return {
    type: SET_USER_AGENZIA,
    agenzia,
  };
}

export function lockUserAgenzia() {
  return {
    type: LOCK_USER_AGENZIA,
  };
}

export function unlockUserAgenzia() {
  return {
    type: UNLOCK_USER_AGENZIA,
  };
}

export function setErrorUserAcl() {
  return {
    type: ERROR_USER_ACL,
  };
}



// WEBPACK FOOTER //
// ./app/containers/Auth/actions.js